// extracted by mini-css-extract-plugin
module.exports = {"login-container":"Login_login-container__MoS_K","google-login-wrapper":"Login_google-login-wrapper__2K0yl"};